import Model from '@/lib/data/Model';
import Store from '@/store/store';

class FormQuestionDataComment extends Model {
    static idProperty = 'id';

    visible = true;

    fields = [
        { name: 'id' },
        { name: 'form_ques_data_id' },
        { name: 'user_id' },
        { name: 'data_comment' },
        { name: 'record_date_utc' },
    ];

    constructor(data) {
        super(data);
        this.init();
    }

    get reviewer() {
        return Store.getters.context.users.find((item) => item.id == this.user_id);
    }

    api = [
        {
            name: 'create',
            method: 'POST',
            url: '/visit/savecomment',
            associated: true,
        },
    ];
}

export default FormQuestionDataComment;
